<template>
    <div class="hover-card multi-card d-block mb-3 h-100 clickable-row" @click="goToPost" :key="post.id" :id="`post-${post.id}`" style="cursor: pointer;"
         :class="{'post_needs_moderation': post.moderation_status === 'pending'}"
    >
        <div class="card-image-top" v-if="post.image_main">
            <img :src="post.image_main" alt="Post Image" class="img-fluid">
        </div>
        <div class="card-body h-100" style="display:flex; flex-direction:column; flex:1; position: relative;">


            <b-modal v-model="showDeleteConfirmModal"
                     title="Confirm Deletion"
                     ok-title="Yes"
                     cancel-title="No"
                     @ok="deletePost">
                <p class="my-2">Are you sure you want to delete this post?</p>
            </b-modal>

            <div class="d-flex align-items-center">
                <div v-if="likeBoxPosition === 'left' && options.enable_voting" style="width: 75px; flex-shrink: 0;">
                    <like-box v-if="options.enable_voting" :post="post" :display-number-votes="true" @click.stop></like-box>
                </div>

                <div class="flex-grow-1">
                    <div class="d-flex justify-content-between">
                        <a :href="post.url" class="post-link">
                            <h6 class="m-0 p-0" style="word-wrap: break-word;">
                                <span v-if="post.loading"><img src="/loading.svg" style="height: 20px;" /></span>
                                {{ post.title }}
                                <span v-if="portalDisplayPostId" class="post_uid">{{ post.uid }}</span>
                                <span class="badge badge-warning" v-if="!post.is_published">Draft</span>
                            </h6>
                        </a>

                        <b-dropdown
                            v-if="isAdmin"
                            variant="outline"
                            size="sm"
                            no-caret
                            right
                            class="post-menu-dropdown"
                            toggle-class="card-menu-button"
                            :boundary="'viewport'"
                        >
                            <template v-slot:button-content>
                                <b-icon icon="gear" aria-hidden="true"></b-icon>
                            </template>
                            <b-dropdown-item @click.stop="goToPost">Open post</b-dropdown-item>
                            <b-dropdown-item @click.stop="editPost">Edit post</b-dropdown-item>
                            <b-dropdown-item @click.stop="editPost">Add image</b-dropdown-item>
                            <b-dropdown-item @click.stop="editPost">Edit status/section</b-dropdown-item>
                            <b-dropdown-item @click.stop="togglePublish">
                                {{ post.is_published ? 'Unpublish' : 'Publish' }}
                            </b-dropdown-item>
                            <b-dropdown-item @click.stop="showDeleteConfirmModal = true">Delete</b-dropdown-item>
                        </b-dropdown>
                    </div>

                    <p v-if="options.display_short_description" class="flex-text pt-2 mb-0 pb-0" v-html="post.description_short"></p>

                    <div class="d-flex justify-content-between align-items-end w-100">
                        <div class="flex-grow-1 pr-2" style="word-wrap: break-word; min-width: 0; flex: 1;">
                            <status-badge v-if="options.display_status" :status="post.status" size="sm" class="mt-2" />

                            <category-badge v-if="options.display_categories" class="mt-2" v-for="category in post.categories" :key="category.id" :category="category" />

                            <span v-if="post.version" class="badge badge-sm badge-light text-muted text-nowrap mt-2">
                                <i class="fa fa-tag"></i> {{ post.version }}
                            </span>

                            <span v-if="post.release" class="badge badge-sm badge-light text-muted text-nowrap mt-2">
                                <i class="fa fa-cube"></i> {{ post.release }}
                            </span>

                            <span v-if="post.platform" class="badge badge-sm badge-light text-muted text-nowrap mt-2">
                                <i class="fa fa-desktop"></i> {{ post.platform }}
                            </span>

                            <span v-if="options.display_number_comments && post.comments_count > 0" class="badge badge-sm badge-light text-muted text-nowrap mt-2">
                                <i class="fa fa-commenting-o"></i> {{ post.comments_count }}
                            </span>
                        </div>

                        <like-box v-if="likeBoxPosition === 'right' && options.enable_voting" :post="post" :display-number-votes="!!options.display_number_votes"  @click.stop></like-box>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import CategoryBadge from './CategoryBadge.vue';
import StatusBadge from './StatusBadge.vue';
import LikeBox from "./LikeBox.vue";
import NotificationPop
    from "../mixins/NotificationPop";

export default {
    components: {
        CategoryBadge,
        StatusBadge,
        LikeBox
    },
    mixins: [NotificationPop],
    data() {
        return {
            showDeleteConfirmModal: false
        }
    },
    props: {
        post: Object,
        options: Object,
        portalDisplayPostId: Boolean,
        isAdmin: {
            type: Boolean,
            required: true
        },
        likeBoxPosition: {
            type: String,
            default: 'right'
        }
    },
    methods: {
        goToPost() {
            if (event.target.closest('.post-link')) {
                // If it was the a-href, do nothing and allow the default anchor behavior
                //return;
            }
            window.location.href = this.post.url;
        },
        editPost() {
            window.location.href = this.post.url_edit
        },
        togglePublish() {
            this.$http.put(`/http_api/posts/${this.post.key}/toggle-publish`)
                .then(response => {
                    console.log(response)
                    this.post.is_published = response.data.data.is_published;
                    this.popNotification('Post updated successfully!', 'success');
                    this.$emit('post-updated', this.post);
                })
                .catch(error => {
                    console.error('Error toggling publish status:', error);
                    this.popNotification('Failed to update the post. Please try again.', 'danger');
                    // Handle error (e.g., show an error message to the user)
                });
        },
        deletePost() {
            this.$http.delete(`/http_api/posts/${this.post.id}`)
                .then(() => {
                    this.showDeleteConfirmModal = false; // Close the modal after deletion
                    this.$emit('post-deleted', this.post.id);
                })
                .catch(error => {
                    console.error('Error deleting post:', error);
                    this.popNotification('Failed to delete the post. Please try again.', 'danger');
                });
        }

    },
};
</script>

<style scoped>
.post-menu-dropdown {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.hover-card:hover .post-menu-dropdown {
    opacity: 1;
}

::v-deep .dropdown-menu {
    max-height: calc(100vh - 20px);
    overflow-y: auto;
}

::v-deep .card-menu-button {
    padding: 0.25rem 0.5rem;
    background: transparent;
    border: 1px solid #6c757d;
    border-radius: 0.25rem;
}

::v-deep .card-menu-button:hover {
    background-color: rgba(108, 117, 125, 0.1);
}

::v-deep .dropdown.show .card-menu-button {
    background-color: rgba(108, 117, 125, 0.1);
}

.hover-card:hover .post-menu-dropdown {
    z-index: 1001;
}
</style>